<template>
  <div>
    <!-- TOP AREA -->
    <div
      style="
        display: flex;
        grid-gap: 10px;
        align-items: center;
      "
    >
      <SearchBar
        style="margin: 10px;"
        :is_live_emit="true"
        foreground_color="#FFF"
        max_width="256"
        @search="search_term = $event;"
      />
      <!-- <ToggleCapsule
        :is_active="hashtag_toggle"
        background_color="#121212"
        foreground_color="#FFF"
        @toggleClicked="hashtag_toggle = !hashtag_toggle"
      /> -->
      <TText
        :text="`Hashtags ${ hashtag_toggle ? 'on' : 'off' }`"
        :color="'amber lighten-1'"
        :size="12"
        :font_weight="400"
      />
      <!-- disabled ? -->
      <RadialCheckbox
        :is_checked="true"
        color_fill
        giant
        background_color="#FF0000"
      />
    </div>

    <!-- HASHTAG GROUPING -->
    <!-- <div
      v-if="hashtag_toggle"
      style="padding-bottom: 40px;"
    >
      <div
        v-for="cluster in clustered_icons"
        :key="cluster.hashtag"
        style="
          display: flex;
          flex-direction: column;
        "
      >
        <h2 style="margin: 0 10px;">#{{ cluster.hashtag }}</h2>
        <div class="ticon-tile-grid">
          <div
            v-for="element in cluster.array"
            :key="`${cluster.hashtag}-${element.id}`"
            class="ticon-tile"
          >
            <TIcon
              :name="element.id"
              large
            />
            <TText
              :text="`${element.id}`"
              :size="8"
              line_height="2"
            />
          </div>
        </div>
      </div>
    </div> -->

    <!-- EACH IN ALPHABETICAL ORDER -->
    <div
      class="ticon-tile-grid"
      style="padding-bottom: 40px;"
    >
      <!-- v-else -->
      <div
        v-for="icon in icon_ids/*icon in filtered_icons*/"
        :key="icon/*.id*/"
        class="ticon-tile"
      >
        <TIcon
          :name="icon/*.id*/"
          large
        />
        <TText
          :text="`${icon/*.id*/}`"
          :size="8"
          line_height="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import TText from '@/components/Taktify/TText.component.vue';
  import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
  import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
  // import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
  import { TColor } from '@/mixins/TColor.mixin.js'

  export default {
    components: {
      TIcon,
      TText,
      SearchBar,
      RadialCheckbox,
      // ToggleCapsule,
    },

    mixins: [TColor],

    computed: {
      filtered_icons() {
        let terms = this.search_term.split(' ');
        let ret = this.icons;
        terms.forEach(term => {
          // check if id contains search terms or any hashtag
          // gets faster for each consecutive term assuming ret gets smaller
          ret = ret.filter(element => element.id.includes(term) || element.hashtags.filter(hashtag => hashtag.includes(term)).length != 0)
        });
        return ret;
      },

      clustered_icons() {
        // TODO: generate this object
        let obj = { exterior:[], tool:[], ui:[], person:[], sign:[], vehicle:[] };
        let icons = this.filtered_icons;

        // iterate through every hashtag of every icon
        for(let i = 0; i < icons.length; i++) {
          for(let j = 0; j < icons[i].hashtags.length; j++) {
            // push every icon into its respective attribute in obj
            obj[icons[i].hashtags[j]].push(icons[i]);
          }
        }
        let arr = [];
        // convert obj into an array of objects
        for(let hashtag in obj) {
          if(obj[hashtag].length > 0) {
            arr.push({ hashtag: hashtag, array: obj[hashtag], });
          }
        }

        return arr;
      },
    },

    data: () => ({
      search_term: '',
      hashtag_toggle: false,
      icon_ids: ["add-circle-inverted", "add-circle", "ai", "air", "antenna", "area-empty", "area-shaded", "area", "arrow-down", "arrow-left", "arrow-right", "arrow-up", "baloons", "bar-chart", "barrier", "beam-long", "beam-short", "beard", "beer", "bell-off", "bell", "bin", "boot", "broom", "bucket", "bug", "bullet-list", "cable", "cake", "calculator", "calendar-add", "calendar-check", "calendar-delete", "calendar", "caliper", "camera-simple", "camera", "car", "carpet", "carton", "cat", "cement", "chainsaw", "check-circle-inverted", "check-circle", "check-double", "check", "checkbox-radial-empty", "checkbox-radial-filled", "checked-stopwatch", "chemical", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "chopping", "cleaning-trowel-rectangle", "cleaning-trowel-triangle", "cleaning", "clipboard-pencil", "clipboard", "clock-negative", "clock", "close-circle-inverted", "close-circle", "close-octagon-inverted", "close-octagon", "close", "cloud-and-sun", "cloud-rain", "cloud", "clouds-lightning", "coating", "column", "company", "compass", "con-rod-negative", "con-rod", "concrete-mixer", "construction-crane", "construction-palett", "construction-spotlight", "construction", "container-perspective", "container-pulled-up", "copy-extra", "copy", "cordless-screwdriver", "core-drill", "couch", "crane", "credit-card", "crop", "crossed-hammer-screwdriver", "crossed-pencil-ruler", "crossed-wrench-screwdriver", "crown", "cube-negative", "cube-nubs", "cube-top", "cube", "cup", "cutter", "cycle", "dirndl", "door-open", "door", "download-edges", "download", "drag-handle-horizontal", "drag-handle-vertical", "drainage-droplet", "drainage-waves", "droplet-splash", "drywall", "dumbbell", "dunce", "elevator", "email", "empty-paper", "end", "error", "excavator-large", "excavator", "exclamation-circle-inverted", "exclamation-circle", "exclamation-octagon-inverted", "exclamation-octagon", "exclamation-triangle-negative", "exclamation-triangle", "fence", "file-add", "file-check", "file-remove", "file", "filter-inverted", "filter", "finish-line", "fire-extinguisher", "flag-simple", "flag", "flame-negative", "flame", "floors", "floppy-disc", "flower", "folder", "fork-lift", "fragile", "garage-door", "garage", "gear-defect", "gear", "gears", "globe", "glove", "goblet", "grid-dots", "grid-rectangle", "hammer", "handshake", "hash-tag", "heart", "helmet", "home", "hook", "hour-glass-empty", "hour-glass", "house-chimney", "house-flat-roof", "house-split", "identity", "image-add", "image-delete", "image", "info", "insulation", "jackhammer", "key-modern", "key-old", "ladder", "language", "laptop", "leather-pants", "led", "lift-up", "light-bulb-capsule", "light-bulb-pear", "link-defect", "link", "location-inverted", "location", "lock-closed-warning", "lock-closed", "lock-open", "lock", "login", "logistic", "logout", "lucky", "magnifying-glass", "mail", "material-api", "measure", "megaphone", "menu-down", "menu-left", "menu-right", "menu-up", "metal-saw", "microphone", "mobile-phone", "money", "moon", "nail", "no-walking", "nut-perspective", "nut-top", "packet-on-pallet", "packet-share", "packet", "paint-brush", "paint-bucket", "paint-frame", "paint-roller-negative", "paint-roller", "paling", "panda", "panorama", "paper-roll", "paperclip", "parquet-tile", "parquet", "pause-outlined", "pause", "pencil", "person-add-group", "person-add", "person-boxed", "person-crowned", "person-delete-group", "person-delete", "person-helmet", "person-standing", "person-stars", "person", "persons-two", "perspective-ceiling", "perspective-floor", "perspective-walls", "phone", "pin", "pipes-connected", "pipes-u-shaped", "plan-cog", "plan", "plane-in-flight", "plane-landing", "plane-lift-off", "plane", "plant", "play-outlined", "play", "poll", "pouring-diagonal", "pouring-horizontal", "power-plug-rounded", "power-plug-sharp", "power-plug-slim", "power-socket-a", "power-socket-b", "power-socket-c", "power-socket-f", "power-socket-i", "power", "present", "project-plan", "properties", "property", "publish", "pull", "puzzle", "pylon", "qr-code", "quality", "radiator-capsule", "radiator-rectangle", "rail-tracks", "raised-floor", "rebar", "restart", "rhombus", "road-roller", "roll-out", "roll", "roof-perspective", "roof-profile", "roof-tile-single", "roof-tiles-wavy", "roof-tiles", "ruler", "sack", "safety-glasses", "saw-blade", "saw", "sawing", "scaffolding", "scale-down", "scale-up", "scissor-lift", "scraper", "screen", "screw-head-cross", "screw-head-hexagon", "screw-head-slit", "screw", "screwdriver", "send", "server", "seven", "share-extra", "share", "shopping-cart", "shovel", "shower", "sign-close", "sign-minus", "sign-plus", "sign-sum", "signal", "silicone-syringe", "simulation-01-block-foundation", "simulation-02-strip-foundation", "simulation-03-bottom-connector", "simulation-04-column", "simulation-05-top-connector", "simulation-06-beam", "simulation-07-gutter", "simulation-08-roof-connector", "simulation-09-roof", "simulation-10-wall", "simulation-11-floor", "sink", "skull", "slab-negative", "slab", "smartphone", "smoothing", "snow-flake-variation", "snow-flake", "solar-pannel", "spade", "spark", "sparkle", "sparkling-wine", "speech-bubble-check", "speech-bubble-text", "speech-bubble", "speedometer", "spirit-level-zoomed-in", "spirit-level", "sprinkler-alternative", "sprinkler", "stage", "stairs-massive", "stairs", "star", "start", "steel-stage", "steering-wheel", "stonemason", "stopwatch", "street", "strike-through-active", "strike-through-inactive", "sun", "swap-horizontal", "swap-vertical", "takt-autopilots", "takt-journal", "takt-plan-sequence", "takt-plan-train", "takt-plan-waggon", "takt-plan-workpackage", "takt-plan", "takt-settings", "takt-structure", "takt-wallet", "tape-measure", "tape", "thermometer-cold", "thermometer-hot", "thumbs-down", "thumbs-up", "tile-multiple", "tile-placing", "tile", "time-effort-current", "time-effort", "toilet-front", "toilet-large", "toilet", "toolbox-flat", "toolbox-rounded", "toolbox-wooden", "train", "tram", "truck-concrete-mixer", "truck-container", "truck-heavy", "truck-loaded", "truck", "underfloor-heating", "ventilation-half-circles", "ventilation", "vertical-dots", "visibility-off", "visibility-on", "waggon", "wall-brick-large", "wall-brick", "wall-plastered", "wall-unfinished", "wallet", "wallpaper", "watch-pie-chart", "water-drop", "water-tap-large", "water-tap-medium", "water-tap-small", "weight", "welding-machine", "welding-mask", "wheel-barrow", "window-casement", "window-double-hung", "window-rounded", "window-square", "workbench", "worker-shovel", "worker-sledgehammer", "wrecking-ball", "wrench", "zoom-in", "zoom-out", ],

      icons: [
        {id: 'flower', hashtags: ['exterior', ]},
        {id: 'chainsaw', hashtags: ['tool', ]},
        {id: 'folder', hashtags: ['ui', ]},
        {id: 'star', hashtags: ['ui', ]},
        {id: 'worker-shovel', hashtags: ['person', 'exterior', ]},
        {id: 'exclamation-triangle', hashtags: ['ui', 'sign', ]},
        {id: 'exclamation-octagon', hashtags: ['ui', 'sign', ]},
        {id: 'car', hashtags: ['vehicle', ]},
        {id: 'excavator', hashtags: ['vehicle', 'exterior', ]},
        {id: 'excavator-large', hashtags: ['vehicle', 'exterior', ]},
        {id: 'hammer', hashtags: ['tool', ]},
      ],

      hashtags: ['exterior', 'tool', 'ui', 'person', 'sign', 'vehicle'],
    }),

    methods: {

    },
  }
</script>

<style>
.ticon-tile {
  width: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  border: 1px solid #444;
}
.ticon-tile-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  grid-gap: 5px;
  margin: 10px;
}
</style>
